import styled from 'styled-components'

import { VisibleScrollbarStyle } from '@/styles/scrollbar'

export const ScrollableContainer = styled.div`
  ${({ theme }) => `
    margin: 0 -${theme.UI.SpacingPx.Space6};
    padding: 0 ${theme.UI.SpacingPx.Space6};
  `}
  ${VisibleScrollbarStyle}
`
